<template>
  <div></div>
</template>
<script>
export default {
  name: "PaymentTypeMissing"
};
</script>
